export default "__VITE_ASSET__CrfcL9CV__"